/**
 * The registration page of the partner cabinet (a separate app; its route `/auth/register`), where a
 * logistics, insurance or inspection company signs itself up (app#321). Null when this build names no
 * partner cabinet: `Plans` then shows no line rather than a link to the storefront's own origin.
 */
export const partnerRegistrationUrl = (cabinetUrl: string | undefined): string | null => {
  const origin = (cabinetUrl ?? '').trim().replace(/\/+$/, '');

  return origin ? `${origin}/auth/register` : null;
};
